export default __webpack_public_path__ + "static/media/mineral.3e14e59f.jpg";